<div class="x_btns">
  @for (button of buttons; track button) {
    <button
      appThrottleClick
      class="x_btn x_primary"
      [ngClass]="button.classNames"
      (throttledClick)="selectButton(button)"
      [disabled]="getButtonDynamicProperty(button, 'disabled') | async"
      [hidden]="getButtonDynamicProperty(button, 'hidden') | async"
    >
      {{ button?.caption || button.name | translate }}
    </button>
  }
</div>
